<template>
  <div class="text-wings">
    <span class="left-wing" :style="{width:wingWidth, height:height + 'px', background:color}"></span>
    <span class="right-wing" :style="{width:wingWidth, height:height + 'px', background:color}"></span>
    <div ref="text" class="text">
      <slot>PUT YOUR TITLE HERE</slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      distance: {
        type: Number,
        required: false,
        default: 15
      },
      height: {
        type: Number,
        required: false,
        default: 1
      },
      color: {
        type: String,
        required: false,
        default: "currentColor"
      }
    },
    data() {
      return {
        textWidth: null,
        windowWidth: null,
        elementWidth: null
      }
    },
    computed: {
      wingWidth() {
        let wingWidth = (this.elementWidth - this.textWidth) / 2;
        wingWidth -= this.distance;
        wingWidth += 'px';
        return wingWidth;
      },
    },
    mounted() {
      const component = this

      component.elementWidth = component.$el.clientWidth;
      component.textWidth = component.$refs.text.clientWidth;

      window.addEventListener('resize', () => {
        component.elementWidth = component.$el.clientWidth;
      })

      // document.fonts.ready.then(function () {
      //   component.elementWidth = component.$el.clientWidth;
      //   component.textWidth = component.$refs.text.clientWidth;

      //   window.addEventListener('resize', () => {
      //     component.elementWidth = component.$el.clientWidth;
      //   })
      // })
    }
  }
</script>

<style lang="scss">
  text-wings {
    text-align: center;
  }

  .text-wings {
    position: relative;
    display: block;
    width: 100%;

    .text {
      display: inline-block;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
    }

    .left-wing,
    .right-wing {
      content: "";
      display: block;
      position: absolute;
      top: 50%;
    }

    .left-wing {
      left: 0;
    }

    .right-wing {
      right: 0;
    }
  }
</style>